import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function NumberRange(start: number, end: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const valueOfControl: string = control.value;
    if (!control.value) {
      return null;
    } else if (allowNumberRange(valueOfControl.split(" ").join(""))) {
      return null;
    } else {
      return { allowNumberRange: true };
    }
  };
  function allowNumberRange(identity: string) {
    return +identity >= start && +identity <= end
  }
}
